import React from 'react';
import PropTypes from 'prop-types';

import Controls from './controls';
import Message from './message';
import Modal from 'components/modal';

export default function CreateListingSuccess({ listing, onClose }) {
  return <React.Fragment>
    <Modal.Body>
      <Message listing={listing} />
    </Modal.Body>

    <Modal.Footer>
      <Controls listing={listing} onClose={onClose} />
    </Modal.Footer>
  </React.Fragment>;
}

CreateListingSuccess.propTypes = {
  listing: PropTypes.object,
  onClose: PropTypes.func.isRequired,
};
